import { SubscriptionDiscount } from './subscription.model';

export function applyDiscount(price: number, discount: SubscriptionDiscount): number {
  const priceInCents = Math.round(price * 100);
  const discountInCents =
    discount.percentOff != null
      ? Math.round((priceInCents * discount.percentOff) / 100)
      : Math.round((discount.amountOff ?? 0) * 100);
  return Math.max(0, priceInCents - discountInCents) / 100;
}

export function getDiscountTranslationKey(discount: SubscriptionDiscount): string {
  const type = discount.percentOff != null ? 'percent' : 'amount';
  return `subscription.new-usage.discount.${type}${discount.endDate ? '-until' : ''}`;
}

export function getPriceDigitsInfo(price: number): string {
  return Number.isInteger(price) ? '1.0-0' : '1.2-2';
}
